import { EventEmitter, Injectable } from '@angular/core';
import { HttpService, Search } from '@docpath/linces-angular-components/common';
import { DpModalService } from '@docpath/webcomponents';
import { EndPoints } from 'src/app/constants/end-points';

import { Dge } from '../models/dge';


@Injectable({
    providedIn: 'root'
})
export class EnginesHttpService {

    readonly relativeUrl = `${EndPoints.ENDPOINT_WEB_API}/${EndPoints.ENDPOINT_CONFIGURATION}/${EndPoints.ENDPOINT_CONFIGURATION_DGES}`;

    private readonly i18nPrefix = 'engines-config';

    showLoadingTableChanged: EventEmitter<boolean> = new EventEmitter();

    constructor(
        private readonly httpService: HttpService,
        private readonly modalService: DpModalService
    ) { }

    getDges(search: Search, suscribe: (result: Dge[], totalSize: number) => void): void {

        const searchBase64 = btoa(JSON.stringify(search));
        this.showLoadingTableChanged.emit(true);
        this.httpService.get({
            relativeUrl: this.relativeUrl,
            queryParameters: { search: searchBase64 },
            suscribe: response => {
                const responseBody = response.result as unknown as Search,
                    result = responseBody.result as Dge[],
                    totalSize = responseBody.paginator?.totalSize ?? 0;
                this.showLoadingTableChanged.emit(false);
                suscribe(result, totalSize);
            },
            suscribeOnError: () => {
                this.showLoadingTableChanged.emit(false);
            }
        });

    }

    unlinkDge(dge: Dge, remove: boolean, suscribe: () => void): void {

        this.httpService.patch(undefined, {
            relativeUrl: `${this.relativeUrl}/${EndPoints.ENDPOINT_DGE_UNLINK}`,
            queryParameters: { id: dge.id },
            loading: true,
            suscribe,
            catchError: (statusCode, message, messageParameters) => this.processUnlinkDgeError(message, messageParameters, dge, remove, suscribe),
            toast: `${this.i18nPrefix}.toast.unlink-success`
        });

    }

    private unlinkWarningDge(dge: Dge, remove: boolean, suscribe: () => void): void {

        this.httpService.patch(undefined, {
            relativeUrl: `${this.relativeUrl}/${EndPoints.ENDPOINT_DGE_WARNING_UNLINK}`,
            queryParameters: { id: dge.id },
            loading: true,
            suscribe,
            toast: `${this.i18nPrefix}.toast.unlink-success`
        });

    }

    private processUnlinkDgeError(message: string, messageParameters: Record<string, string> | undefined, dge: Dge, remove: boolean, suscribe: () => void): void {

        if (message === 'linces.http.error.engines.not-connected') {
            const modal = this.modalService.openQuestion(`${this.i18nPrefix}.modal.warning-unlink-question`);
            modal.componentInstance.accepted.subscribe(() => this.unlinkWarningDge(dge, remove, suscribe));
        } else {
            this.modalService.openError(message, messageParameters);
        }

    }

    deleteDge(dge: Dge, suscribe: () => void): void {

        this.httpService.delete({
            relativeUrl: `${this.relativeUrl}`,
            queryParameters: { id: dge.id },
            loading: true,
            suscribe,
            toast: `${this.i18nPrefix}.toast.delete-success`
        });

    }

}